import type { WithResponsive } from '@sunrise-ui/primitives';
import { Colors, TextReg, useDynamicStyles } from '@sunrise-ui/primitives';
import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

export enum ProfileViewMode {
  Upcoming = 'upcoming',
  Past = 'past',
}

interface ProfileViewToggleProps {
  value: ProfileViewMode;
  onValueChange: (value: ProfileViewMode) => void;
}

export function ProfileViewToggle({
  value,
  onValueChange,
}: ProfileViewToggleProps) {
  const styles = useDynamicStyles(createStyles);

  return (
    <View style={styles.toggleContainer}>
      <TouchableOpacity
        style={[
          styles.toggleButton,
          value === ProfileViewMode.Upcoming && styles.toggleButtonActive,
        ]}
        onPress={() => onValueChange(ProfileViewMode.Upcoming)}
        activeOpacity={0.7}
      >
        <TextReg
          style={[
            styles.toggleButtonText,
            value === ProfileViewMode.Upcoming && styles.toggleButtonTextActive,
          ]}
        >
          Upcoming
        </TextReg>
      </TouchableOpacity>
      <TouchableOpacity
        style={[
          styles.toggleButton,
          value === ProfileViewMode.Past && styles.toggleButtonActive,
        ]}
        onPress={() => onValueChange(ProfileViewMode.Past)}
        activeOpacity={0.7}
      >
        <TextReg
          style={[
            styles.toggleButtonText,
            value === ProfileViewMode.Past && styles.toggleButtonTextActive,
          ]}
        >
          Past
        </TextReg>
      </TouchableOpacity>
    </View>
  );
}

const createStyles = ({ isMobile }: WithResponsive) =>
  StyleSheet.create({
    toggleContainer: {
      flexDirection: 'row',
      backgroundColor: Colors.opacity05,
      borderRadius: isMobile ? 18 : 24,
      padding: 3,
    },
    toggleButton: {
      borderRadius: isMobile ? 15 : 21,
      height: isMobile ? 28 : 40,
      paddingHorizontal: isMobile ? 18 : 26,
      justifyContent: 'center',
      alignItems: 'center',
    },
    toggleButtonActive: {
      backgroundColor: Colors.opacity20,
    },
    toggleButtonText: {
      fontSize: isMobile ? 12 : 14,
      color: Colors.text,
      fontWeight: '500',
      textAlign: 'center',
    },
    toggleButtonTextActive: {
      fontWeight: '600',
    },
  });
